import {
    createHightouchEventFactory,
    type EventFactory
} from '@thorne/hightouch-clickstream'

/**
 * Creates and provides the client-side Hightouch clickstream event factory.
 *
 * The factory is initialized from public runtime config when Hightouch events
 * are enabled and a write key is available. It is exposed as `$hightouchEvents`
 * so other client plugins and components can send clickstream events, while
 * disabled or unconfigured environments receive `null`.
 */
export default defineNuxtPlugin({
    name: 'hightouch-clickstream',
    setup() {
        const config = useRuntimeConfig()
        const hightouchEventsEnabled = String(config.public.hightouchEventsEnabled) === 'true'
        const writeKey = config.public.hightouchWriteKey as string | undefined
        const apiHost = config.public.hightouchApiHost as string | undefined

        let hightouchEvents: EventFactory | null = null

        if (hightouchEventsEnabled && writeKey) {
            hightouchEvents = createHightouchEventFactory({
                writeKey,
                initOptions: { apiHost },
                overwriteCampaign: true,
                overwriteClickIds: true,
                autoPage: true
            })
        }

        return {
            provide: {
                hightouchEvents
            }
        }
    }
})
